export const changeDateToStartAtMidnight = (d: Date | null = null) => {
  const newDate = d ?? Date.now() - 7 * 24 * 60 * 60 * 1000
  const date = new Date(newDate)
  date.setHours(1, 0, 0, 0)
  return date
}

export const formatDate = (date: string | Date) => {
  const d = new Date(date)
  return d.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  })
}

export const formatRelativeDate = (date: string | Date) => {
  const d = new Date(date)
  const now = new Date()
  const diffInMs = now.getTime() - d.getTime()
  const diffInSeconds = Math.floor(diffInMs / 1000)
  const diffInMinutes = Math.floor(diffInSeconds / 60)
  const diffInHours = Math.floor(diffInMinutes / 60)
  const diffInDays = Math.floor(diffInHours / 24)

  if (diffInSeconds < 60) {
    return 'just now'
  } else if (diffInMinutes < 60) {
    return `${diffInMinutes}m ago`
  } else if (diffInHours < 24) {
    return `${diffInHours}h ago`
  } else if (diffInDays < 30) {
    return `${diffInDays}d ago`
  } else {
    return formatDate(date)
  }
}
